export function isMarketingEmailAsset(asset) {
  return asset.portableType === 'marketing-email';
}